import Swiper from 'swiper';
import { SwiperOptions } from 'swiper/types';
export interface SliderInstance {
  init: () => void;
  goToSlide: (slideIndex: number) => void;
}

const ColorSchemeCompareSlider = (
  sliderId: string,
): SliderInstance | undefined => {
  const sliderEl = document.getElementById(sliderId);

  if (!sliderEl) {
    console.warn(`${sliderId} - compare slider not found`);
    return;
  }

  let swiperInstance: Swiper | undefined;

  const goToSlide = (slideIndex: number) => {
    if (swiperInstance) {
      swiperInstance.slideTo(slideIndex);
    } else {
      console.warn(`Swiper instance not initialized for ${sliderId}`);
    }
  };

  const init = () => {
    const options: SwiperOptions = {
      slidesPerView: 1,
      spaceBetween: 0,
    };

    // Initialize the Swiper instance and store it in the swiperInstance variable
    swiperInstance = new Swiper(sliderEl, options);
  };

  return {
    init,
    goToSlide,
  };
};

export default ColorSchemeCompareSlider;
